module.exports = __webpack_public_path__ + "img/straight-rail-vertical-stone-path-background.f5175ffc.png";